import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { Shipment, shipmentSchema } from '@/shipment/api/types';
import { dateTimeSchema } from '@/utilities/date-time-schema';
import { z } from 'zod';

const deliverShipmentResponseSchema = z.object({
  data: shipmentSchema,
  metadata: responseMetadataSchema,
});

export const deliverShipmentSchema = z.object({
  deliveredAt: dateTimeSchema,
  deliveredAtTimezone: z.string().optional(),
  deliveryLocationId: z.string(),
  deliveryNote: z.string().optional(),
});

export type DeliverShipmentRequest = z.infer<typeof deliverShipmentSchema>;

/**
 * Deliver a new shipment with the specified details.
 *
 * @param request - The shipment details to deliver
 * @param shipmentKey - The key from the shipment
 * @returns The delivered shipment
 */
export async function deliverShipment(
  shipmentKey: string,
  request: DeliverShipmentRequest
): Promise<Shipment> {
  const url = `/v1/shipment/${shipmentKey}/deliver`;
  const response = await api.post(url, request);

  const { data } = await parseResponse(
    deliverShipmentResponseSchema,
    response.data,
    {
      schemaName: 'DeliverShipment',
      endpoint: url,
    }
  );
  return data;
}
